type ImageLoader = (fileId: string) => Promise<Blob>;

let imageLoader: ImageLoader | null = null;

export function configureImageLoader(loader: ImageLoader): void {
  imageLoader = loader;
}

export async function loadImageFile(fileId: string): Promise<Blob | null> {
  if (!imageLoader) return null;
  return imageLoader(fileId);
}
